module.exports = __webpack_public_path__ + "images/cf1d9c9516ee9d87f7dfe074074573e3.svg";